import React from 'react';
import { TableContainer, Table, Tbody, Tr, Td, Link } from '@chakra-ui/react';

const MetadataTab = ({ area, people_ID, place_ID, certName, tx, onViewTransaction }) => {
  return (
    <TableContainer w="1096px" margin="auto">
      <Table variant="simple">
        <Tbody>
          <Tr>
            <Td fontWeight="bold">縣市別</Td>
            <Td>{area}</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold">運作人管編/名稱</Td>
            <Td>{people_ID}</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold">運作場所管編/名稱</Td>
            <Td>{place_ID}</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold">證件編號</Td>
            <Td>{certName}</Td>
          </Tr>
          <Tr>
            <Td fontWeight="bold">鏈上Tx</Td>
            <Td>
              <Link
                onClick={(e) => {
                  e.preventDefault();
                  onViewTransaction('0x' + tx);
                }}
              >
                {'0x' + tx}
              </Link>
            </Td>
          </Tr>
        </Tbody>
      </Table>
    </TableContainer>
  );
};

export default MetadataTab;
